const translations = {
  "en": {
    "Ask": "Ask",
    "Give me more info about this report": "Give me more info about this report",
    "Market Movers %{var0}": "Market Movers %{var0}",
    "Portfolio Tracker %{var0}": "Portfolio Tracker %{var0}"
  },
  "zh-tw": {
    "Ask": "提問",
    "Give me more info about this report": "了解此報告詳情",
    "Market Movers %{var0}": "市場異動股 %{var0}",
    "Portfolio Tracker %{var0}": "投資組合追蹤 %{var0}"
  }
};

export default translations;
